import { useEffect, useRef, useState } from "react"
import useWindowSize from "../../../hooks/useWindowSize";
import { useSelector } from "react-redux";
import { postSync } from "../../../helpers/api_helper"

const AgentReportIframe = () => {
  const { agentSelf } = useSelector(state => state.AgentSelf);
  const ref = useRef(null);
  const [iframeSrc, setIframeSrc] = useState('');

  const windowSize = useWindowSize();

  useEffect(() => {
    if (ref.current) {
      ref.current.height = windowSize.height + 90 + 'px';
    }
  }, [windowSize.height]);

  useEffect(() => {
    const generateIFrameLink = async () => {
      const params = {
        agent_id: agentSelf?.id || '',
      };

      const url = `/dashboard/dashboard-url/`;
      try {
        const result = await postSync(url, {
          id: '501',
          params,
        });
        setIframeSrc(result?.url || '');
      } catch (error) {
        console.error("Error generating iframe link:", error);
      }
    };

    if (agentSelf?.id) {
      generateIFrameLink();
    }
  }, [agentSelf?.id]);

  return (
    <iframe
      ref={ref}
      src={iframeSrc}
      width="100%"
      height="100%"
      allowFullScreen
      allowTransparency
    ></iframe>
  );
};

export default AgentReportIframe;
